import React, { useState } from 'react';
import api from './api';

const ROLES = ['Director', 'Project_Lead', 'Manager', 'Engineer'];
const ROLE_LABELS = { Director: 'Directeur', Project_Lead: 'Chef de projet', Manager: 'Manager', Engineer: 'Ingénieur' };

function UserModal({ user, onClose, onSaved }) {
  const isEdit = !!user;
  const [form, setForm] = useState({
    username: user?.username || '',
    email: user?.email || '',
    password: '',
    role: user?.role || 'Engineer',
    department: user?.department || '',
    active: user?.active !== false,
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (field) => (e) => {
    const value = field === 'active' ? e.target.checked : e.target.value;
    setForm({ ...form, [field]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      if (isEdit) {
        const { password, ...rest } = form;
        await api.put(`/users/${user.id}`, rest);
      } else {
        if (!form.password || form.password.length < 6) {
          setError('Le mot de passe initial doit contenir au moins 6 caractères.');
          setSaving(false);
          return;
        }
        await api.post('/users', form);
      }
      onSaved();
    } catch (err) {
      setError(err.response?.data?.message || "Impossible d'enregistrer l'utilisateur.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 style={{ margin: 0 }}>{isEdit ? "Modifier l'utilisateur" : 'Nouvel utilisateur'}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        {error && <div className="error-message" style={{ marginBottom: 14 }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Identifiant</label>
              <input type="text" value={form.username} onChange={handleChange('username')} required disabled={isEdit} />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" value={form.email} onChange={handleChange('email')} required />
            </div>
          </div>

          {!isEdit && (
            <div className="form-group">
              <label>Mot de passe initial</label>
              <input type="password" value={form.password} onChange={handleChange('password')} required minLength={6} />
            </div>
          )}

          <div className="form-row">
            <div className="form-group">
              <label>Rôle</label>
              <select value={form.role} onChange={handleChange('role')}>
                {ROLES.map((r) => (
                  <option key={r} value={r}>{ROLE_LABELS[r]}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Département</label>
              <input type="text" value={form.department} onChange={handleChange('department')} />
            </div>
          </div>

          {isEdit && (
            <div className="form-group">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, textTransform: 'none', fontSize: 13 }}>
                <input type="checkbox" checked={form.active} onChange={handleChange('active')} style={{ width: 'auto' }} />
                Compte actif
              </label>
            </div>
          )}

          <div className="modal-footer">
            <button type="button" className="btn" onClick={onClose}>Annuler</button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Enregistrement...' : 'Enregistrer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UserModal;
